import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EPaymentMethod } from "../../../../../../../../dependencies/getContent/constants";
import { produce } from "../../../../../../../../../libs/immer";
import { EStatus } from "../../../../../../../../../constants";
export var submitSberPayUseCase = function submitSberPayUseCase(_ref) {
  var submitSberPayPayment = _ref.submitSberPayPayment,
    getContent = _ref.getContent,
    refreshCaptcha = _ref.refreshCaptcha;
  // Handles case when captcha validation fails
  var handleCaptchaError = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(setState, content) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return refreshCaptcha();
          case 2:
            setState(produce(function (draft) {
              var _draft$scenario, _draft$scenario2;
              if (((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) !== EPaymentMethod.SberPay || !((_draft$scenario2 = draft.scenario) !== null && _draft$scenario2 !== void 0 && _draft$scenario2.captchaInput)) {
                throw new Error('Invalid scenario type');
              }
              draft.scenario.captchaInput = _objectSpread(_objectSpread({}, draft.scenario.captchaInput), {}, {
                value: '',
                errorMessage: content.sberPayPopup.captcha.errorMessage
              });
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCaptchaError(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Handles general error case
  var handleError = function handleError(draft) {
    draft.statusPopup = EStatus.Error;
    draft.scenario = undefined;
  };
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(getState, setState) {
      var _state$scenario, _state$scenario$phone;
      var state, content, status;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            content = getContent();
            if (!(((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== EPaymentMethod.SberPay)) {
              _context2.next = 4;
              break;
            }
            throw new Error('Invalid scenario type');
          case 4:
            if (!((_state$scenario$phone = state.scenario.phoneInput) !== null && _state$scenario$phone !== void 0 && _state$scenario$phone.errorMessage)) {
              _context2.next = 6;
              break;
            }
            return _context2.abrupt("return");
          case 6:
            if (!(state.scenario.step === 0)) {
              _context2.next = 9;
              break;
            }
            setState(function (prev) {
              return produce(prev, function (draft) {
                var _draft$scenario3;
                if (((_draft$scenario3 = draft.scenario) === null || _draft$scenario3 === void 0 ? void 0 : _draft$scenario3.type) === EPaymentMethod.SberPay) {
                  draft.scenario.step = 1;
                }
              });
            });
            return _context2.abrupt("return");
          case 9:
            _context2.prev = 9;
            setState(produce(function (draft) {
              var _draft$scenario4;
              if (((_draft$scenario4 = draft.scenario) === null || _draft$scenario4 === void 0 ? void 0 : _draft$scenario4.type) !== EPaymentMethod.SberPay) return;
              draft.scenario.isLoading = true;
            }));

            // Submit payment and get status
            _context2.next = 13;
            return submitSberPayPayment(getState, setState);
          case 13:
            status = _context2.sent;
            setState(produce(function (draft) {
              var _draft$scenario5;
              if (((_draft$scenario5 = draft.scenario) === null || _draft$scenario5 === void 0 ? void 0 : _draft$scenario5.type) !== EPaymentMethod.SberPay) return;
              draft.scenario.isLoading = false;
            }));
            if (!(status === EStatus.CaptchaError)) {
              _context2.next = 19;
              break;
            }
            _context2.next = 18;
            return handleCaptchaError(setState, content);
          case 18:
            return _context2.abrupt("return");
          case 19:
            // Handle response based on status
            setState(produce(function (draft) {
              var _draft$scenario6, _draft$scenario7;
              if (((_draft$scenario6 = draft.scenario) === null || _draft$scenario6 === void 0 ? void 0 : _draft$scenario6.type) !== EPaymentMethod.SberPay || ((_draft$scenario7 = draft.scenario) === null || _draft$scenario7 === void 0 ? void 0 : _draft$scenario7.step) !== 1) {
                throw new Error('Invalid scenario type');
              }
              draft.statusPopup = status;
              draft.scenario = undefined;
            }));
            _context2.next = 26;
            break;
          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](9);
            console.error(_context2.t0);
            setState(function (prev) {
              return produce(prev, handleError);
            });
          case 26:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[9, 22]]);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};